var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('asc-label-box',{attrs:{"bg-color":_vm.calcBgColor,"color":_vm.calcColor,"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }